import {
  FREQUENCY_OPTIONS,
  CATEGORY_OPTIONS,
  CATEGORY_COLORS,
} from "../constants";

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return "-";
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
  }).format(amount);
};

export const getFrequencyLabel = (frequency) => {
  const found = FREQUENCY_OPTIONS.find((f) => f.value === frequency);
  return found ? found.label : frequency;
};

export const getCategoryLabel = (category) => {
  if (!category) return "-";
  const found = CATEGORY_OPTIONS.find((c) => c.value === category);
  return found ? found.label : category;
};

export const getCategoryColor = (category) => {
  return CATEGORY_COLORS[category] || "default";
};
